import React from "react";
import "./Ad.scss";

function Ad({ index }) {
    // Temp not displaying add.
    return <>{false && <div className="ad"></div>}</>;
}

export default Ad;
